import { render } from "./Faktura.vue?vue&type=template&id=66212f17&scoped=true&lang=html"
import script from "./Faktura.vue?vue&type=script&lang=js"
export * from "./Faktura.vue?vue&type=script&lang=js"

import "./Faktura.vue?vue&type=style&index=0&id=66212f17&lang=css&scoped=true"
script.render = render
script.__scopeId = "data-v-66212f17"

export default script